import axios from 'axios';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import nl from './locales/nl/translation.json';

const setLanguageSideEffects = (lng) => {
  const next = lng === 'nl' ? 'nl' : 'en';
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next;
  }
  axios.defaults.headers.common['Accept-Language'] = next;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

setLanguageSideEffects(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', setLanguageSideEffects);

export default i18n;
